import { render, staticRenderFns } from "./ClientDetailProfile.vue?vue&type=template&id=54fb4468&scoped=true&"
import script from "./ClientDetailProfile.vue?vue&type=script&lang=js&"
export * from "./ClientDetailProfile.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetailProfile.vue?vue&type=style&index=0&id=54fb4468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fb4468",
  null
  
)

export default component.exports